import { API_URL } from "../utils/AppApiUrl";
import { postFile } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";

const UploadSpareImgService = async (baseURL, requestBody, param) => {
  try {
    let formData = new FormData();
    //console.log('paramUp',param)
    if (requestBody) {
      var postData = JSON.stringify(param);
      formData.append("file", requestBody);
      formData.append("spare", postData);
    }
    //console.log('postData',postData)
    const UploadResponse = await postFile(
      tokenHttpClient,
      `${baseURL}${API_URL.spareUpload}`,
      formData
    );

    if (UploadResponse.status === 200) {
      return UploadResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export default UploadSpareImgService;
